module.exports = __webpack_public_path__ + "media/images/login_icon-43f410b174c2c75cf4fedb6206e8bc4a.svg";